import Link from "next/link";
import { Button } from "@/components/ui/button";
import { userIsAdmin, userIsUniversalAdmin } from "@/utils/accessControl";
import { type Session } from "@/types/auth";
import { cn } from "@/lib/utils";

export const NavLinks = ({ 
    session, 
    className 
}: { 
    session: Session | null;
    className?: string;
}) => {
    if (!session) return null;
    return (
        <div className={cn("hidden xl:flex items-center space-x-1 force-dark", className)}>
            <Button variant="ghost" asChild>
                <Link href="/dashboard">
                    Dashboard
                </Link>
            </Button>
            <Button variant="ghost" asChild>
                <Link href="/devicelist">
                    Devices
                </Link>
            </Button>
            <Button variant="ghost" asChild>
                <Link href="/grouplist">
                    Groups
                </Link>
            </Button>
            <Button variant="ghost" asChild>
                <Link href="/reports">
                    Reports
                </Link>
            </Button>
            {/* {!userIsSuperAdmin(session) ? null: <Button variant="ghost" asChild>
            <Link href="/unknowndevices">
                Unknown devices
            </Link>
        </Button>} */}
            {!userIsUniversalAdmin(session) ? null : <Button variant="ghost" asChild>
                <Link href="/deviceconfigurations">
                    Device configurations
                </Link>
            </Button>}
            {/* {!userIsSuperAdmin(session) ? null: <Button variant="ghost" asChild>
            <Link href="/newdeviceconfiguration">
                New configuration
            </Link>
        </Button>} */}
            {userIsAdmin(session) ? <Button variant="ghost" asChild>
                <Link href="/admin">
                    Admin
                </Link>
            </Button> : null}
        </div>
    )
}